/**
 * Configuration utilities for the application
 * Controls verbose logging and other runtime settings
 */

/**
 * Checks if verbose logging is enabled
 * Controlled by REACT_APP_VERBOSE environment variable
 * Defaults to false in production, true in development
 */
export const isVerboseMode = (): boolean => {
  // Check environment variable first
  const envVerbose = process.env.REACT_APP_VERBOSE;
  if (envVerbose !== undefined) {
    return envVerbose.toLowerCase() === 'true';
  }
  
  // Default behavior: verbose in development, non-verbose in production
  // REACT_APP_DEPLOY_MODE can be 'PROD', 'DEV', or undefined
  const deployMode = process.env.REACT_APP_DEPLOY_MODE;
  const isProduction = deployMode === 'PROD' || (!deployMode && process.env.NODE_ENV === 'production');
  
  return !isProduction; // Verbose in dev, quiet in prod
};

/**
 * Logs a message only if verbose mode is enabled
 */
export const verboseLog = (message: string, ...args: any[]): void => {
  if (isVerboseMode()) {
    console.log(message, ...args);
  }
};

/**
 * Logs a warning only if verbose mode is enabled
 */
export const verboseWarn = (message: string, ...args: any[]): void => {
  if (isVerboseMode()) {
    console.warn(message, ...args);
  }
};

/**
 * Logs an error only if verbose mode is enabled
 * Note: Critical errors should use console.error directly if they need to always be logged
 */
export const verboseError = (message: string, ...args: any[]): void => {
  if (isVerboseMode()) {
    console.error(message, ...args);
  }
};

